<template>
  <div
    :class="isNavbarVisible ? 'translate-y-0' : 'translate-y-full'"
    class="flex flex-row justify-between fixed bottom-0 left-0 right-0 z-20 bg-gray-900 w-full md:max-w-md mx-auto overflow-hidden border-t-1 border-t-solid border-t-gray-700 transition-transform duration-300"
    style="height: var(--viva-navbar-height, 6rem);">
    <NuxtLink :to="item.link === 'profile' && unreadCount > 0
              ? {name: item.link, query: {section: 'notifications'}}
              : {name: item.link}" style="height:80px"
              class="flex flex-row pt-2 pb-2 flex-1 min-w-0 px-1 flexCenter relative justify-around bg-gray-900"
              v-for="item in items" :key="item.link">
      <div class="flex flex-col gap-1 justify-start items-center w-full h-full pb-8 pt-2">
        <div class="relative">
          <img :src="item.icon"
               :class="route.name == item.link ? 'navbar-icon-active' : 'navbar-icon-inactive'"
               class="w-7 h-7 object-contain"
          />
          <TheCountBadge
              v-if="item.link === 'profile'"
              :count="unreadCount"
              position-class="-top-1.5 -right-2"
              border-color-class="border-gray-900"
          />
        </div>
        <p class="font-normal text-[10px] text-center leading-tight font-bold whitespace-normal max-w-full"
           :class="route.name == item.link ? 'text-secondary' : 'text-gray-500'">
          {{ item.label }}
        </p>
      </div>
    </NuxtLink>
  </div>
</template>

<style scoped>
@media (max-width: 640px) {
  :deep(a) {
    height: 80px !important;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  :deep(.flex.flex-col) {
    gap: 0.25rem;
  }
}
</style>
<script lang="ts" setup>
import homeIcon from "~/assets/icons/navicon/home.png";
import clubsIcon from "~/assets/icons/navicon/clubs.png";
import matchsIcon from "~/assets/icons/navicon/matchs.png";
import communityIcon from "~/assets/icons/navicon/community.png";
import profileIcon from "~/assets/icons/navicon/profile.png";

const route = useRoute();
const { isNavbarVisible } = useNavbarVisibility();
const { unreadCount, refreshUnreadCount, startPolling } = useGameNotifications();

onMounted(() => {
  refreshUnreadCount();
  startPolling();
});

const items = [
  {
    label: "خانه",
    link: "index",
    icon: homeIcon
  },
  {
    label: "باشگاه ها",
    link: "club",
    icon: clubsIcon
  },
  {
    label: 'مسابقات',
    link: 'competitions',
    icon: matchsIcon,
  },
  {
    label: "کامیونیتی",
    link: "socials",
    icon: communityIcon
  },
  {
    label: "پروفایل",
    link: "profile",
    icon: profileIcon
  }
];
</script>

<style scoped>
.navbar-icon-active {
  filter: brightness(0) saturate(100%) invert(47%) sepia(74%) saturate(2251%) hue-rotate(345deg) brightness(96%) contrast(92%);
}

.navbar-icon-inactive {
  opacity: 0.5;
}
</style>
